<template>
	<v-row no-gutters class="mx-1">
		<v-col cols="12">
			<form @submit.prevent>
				<div class="searchBox d-flex mb-1" id="searchBox">
					<v-icon class="icon search" color="primary">{{ icons.search }}</v-icon>
					<input
						v-model="searchQuery"
						ref="input"
						type="email"
						@focus="preventScroll"
						class="searchInput"
						@focusout="revokeScroll"
						placeholder="Search Stickers"
						@input="searched" />
					<v-icon color="primary" class="justify-self-end clear" v-if="searchQuery" @click="clearSearch">{{
						icons.close
					}}</v-icon>
				</div>
			</form>
			<!-- <v-text-field
				v-model="searchQuery"
				class="search-box mb-1"
				placeholder="Search Stickers..."
				:prepend-inner-icon="icons.search"
				@click="preventScroll"
				@input="searched"
				dense
				outlined
				hide-details>
				<template #append>
					<v-icon v-if="searchQuery" @click="clearSearch">{{ icons.close }}</v-icon>
				</template>
			</v-text-field> -->
		</v-col>
	</v-row>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { mdiMagnify, mdiClose } from '@mdi/js';
import { useStore } from '@/store';

export default {
	props: {
		reset: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, ctx) {
		const searchQuery = ref('');
		const input = ref();

		const store = useStore();
		const isMobile = computed(() => {
			return store.state.isMobile;
		});

		const height = ref();
		height.value = window.innerHeight;

		watch(
			() => props.reset,
			val => {
				if (val) {
					searchQuery.value = null;
				}
			},
		);

		const preventScroll = event => {
			event.preventDefault();
			const box = document.getElementById('searchBox');
			box.classList.toggle('focused');

			// const app = document.getElementById('app');
			// if (app) {

				if (isMobile.value) {
					const userAgent = navigator.userAgent;

					if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
						const panel = document.querySelector('.panel-mobile');
						if (panel) {
							window.scrollTo({
								top: '80px',
								behavior: 'smooth'
							})
							// panel.style.marginTop = '44px';
						}
						
						// setTimeout(() => {
						// 	const panel = document.getElementById('panel');
						// 	height.value = window.innerHeight + ' p ' + panel.offsetHeight;
						// }, 50)
					}
				}
		};

		const revokeScroll = event => {
			const box = document.getElementById('searchBox');
			box.classList.toggle('focused');

			const panel = document.querySelector('.panel-mobile');
			if (panel) {
				// panel.style.marginTop = '0px';
			}
		};

		const searched = () => {
			ctx.emit('onSearch', searchQuery.value);
		};

		const clearSearch = () => {
			searchQuery.value = '';
			searched();
		};

		return {
			height,
			isMobile,
			revokeScroll,
			preventScroll,
			searchQuery,
			searched,
			clearSearch,
			icons: {
				search: mdiMagnify,
				close: mdiClose,
			},
		};
	},
};
</script>

<style lang="scss" scoped>
.searchBox {
	height: 33px;
	width: 100%;
	position: relative;
	background: transparent;
	border: 1px solid var(--v-primary-base);
	border-radius: 4px;

	&.focused {
		border: 1px solid white;
	}

	input {
		width: 95%;
		padding: 0 5px 0 0px;
		font-size: 14px;
		outline: none;
		height: 100%;

		::placeholder {
			color: var(--v-primary-base);
		}

		&:focus {
			outline: none;
		}
	}

	input::placeholder {
		color: var(--v-primary-base) !important;
	}

	.v-icon {
		/* position: absolute; */
		margin-top: 0px;
		margin-left: 8px;
	}

	.v-icon.clear {
		margin-right: 10px;
		margin-top: 0px;
	}
}
</style>
